export default __webpack_public_path__ + "static/media/plus-icon.e124f190.svg";